import * as Website from '../../Config/Website.js';
import * as ToggleCoupon from './Modules/ToggleCoupon.js';
import * as MapAnimation from './Modules/MapAnimation.js';
import * as HotelListAccordion from './Modules/HotelListAccordion.js';
import * as InertialScroll from './Modules/InertialScroll.js';
import * as BackToTop from './Modules/BackToTop.js';
import * as NavAccordion from './Modules/NavAccordion.js';


const preinit = () => {

}

const init = () => {
  ToggleCoupon.init();
  MapAnimation.init();
  HotelListAccordion.init();
  InertialScroll.init();
  BackToTop.init();
  NavAccordion.init();
}

const resize = () => {

}

const resizeW = () => {
}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}